const state = {
  is_login: false, //是否已经登录
  userinfo: {},    // 当前已登录用户的信息
  x_sso_token: '', // ss.token
}
const mutations = {
  SET_IS_LOGIN: (state, is_login) => { 
    state.is_login = is_login || false
  },
  SET_USERINFO: (state, userinfo) => { 
    state.userinfo = userinfo || {}
  },
  SET_X_SSO_TOKEN: (state, x_sso_token) => {
    state.x_sso_token = x_sso_token || ''
  }
}

const actions = {
  settingLoginStatus ({
    commit
  }, is_login) {
    commit('SET_IS_LOGIN', is_login)
  },
  settingUserInfo ({
    commit
  }, userinfo) {
    commit('SET_USERINFO', userinfo)
  },
  settingXssoToken ({
    commit
  }, str_token) {
    commit('SET_X_SSO_TOKEN', str_token)
  }
}

export default {
  namespaced: true,
  mutations,
  state,
  actions
}